import type { LumxClassName } from '@lumx/core/js/types';

/**
 * Component display name.
 */
export const COMPONENT_NAME = 'DatePicker';

/**
 * Component default class name and class prefix.
 */
export const CLASSNAME: LumxClassName<typeof COMPONENT_NAME> = 'lumx-date-picker';
